module.exports = __webpack_public_path__ + "static/img/new-17.f4b9c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-17.png
// module id = AIYW
// module chunks = 0